import { useEffect } from "react"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { useTheme } from "../../theme/ThemeProvider"

export default function FairyHome() {
  const { setTheme, theme } = useTheme()

  useEffect(() => {
    if (theme !== "fairy") {
      setTheme("fairy")
    }
  }, [theme, setTheme])

  return (
    <div
      className="theme-fairy"
      style={{
        minHeight: "100vh",
        padding: "clamp(32px, 8vw, 64px) clamp(16px, 6vw, 32px)",
        background: "linear-gradient(180deg,#f6f7f8 0%,#ffffff 100%)",
        color: "var(--text)",
      }}
    >
      <div
        style={{
          maxWidth: "720px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "clamp(20px, 6vw, 32px)",
        }}
      >
        <header
          style={{
            display: "flex",
            alignItems: "center",
            gap: "18px",
            flexWrap: "wrap",
          }}
        >
          <img src="/assets/pixel/fairy_16.png" alt="Fairy" className="pixel" style={{ width: 48, height: 48 }} />
          <div>
            <div className="mono" style={{ letterSpacing: "0.18em", fontSize: "20px" }}>
              Fairy Garden Variant
            </div>
            <p className="small" style={{ color: "var(--muted)" }}>
              Soft whispers, teal rails, gentler cadence for customer-first brands.
            </p>
          </div>
        </header>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mono"
          style={{
            background: "rgba(255,255,255,0.7)",
            borderRadius: "18px",
            padding: "clamp(20px, 6vw, 28px)",
            letterSpacing: "0.08em",
          }}
        >
          <p style={{ marginBottom: "16px" }}>
            Welcome summoner. The Fairy Garden guides overdue clients with patient whispers and luminous rails. Switch to the Demon Pit anytime for sharper nudges.
          </p>
          <Link
            to="/"
            className="mono"
            style={{
              borderRadius: "999px",
              padding: "12px 22px",
              border: "2px solid var(--rail)",
              textTransform: "uppercase",
              letterSpacing: "0.16em",
              display: "inline-flex",
              gap: "8px",
              alignItems: "center",
              minHeight: "44px",
            }}
          >
            return to demon
          </Link>
        </motion.div>

        <section style={{ display: "grid", gap: "clamp(12px, 3vw, 16px)" }}>
          {["Whispers, not warnings", "Teal rails signal grace", "Opt-in to Fairy per customer"].map((item) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              style={{
                padding: "18px 22px",
                borderRadius: "16px",
                background: "rgba(255,255,255,0.6)",
                border: "2px solid rgba(16,185,129,0.28)",
                color: "var(--text)",
                minHeight: "44px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {item}
            </motion.div>
          ))}
        </section>
      </div>
    </div>
  )
}
